import { css } from '@emotion/react';
import { tokens, applyFont } from '@domain-group/fe-brary';

const { spacing, colors, typography } = tokens;

const SELECT_WIDTH = 156;

export const sortBy = css`
  display: flex;
  align-items: center;
  gap: ${spacing.xs};
`;

export const label = css`
  ${applyFont(typography.body)}
  color: ${colors.neutral.medium.default};
  white-space: nowrap;
`;

export const select = css`
  width: ${SELECT_WIDTH}px;

  button[aria-expanded='true'] {
    border-bottom: 1px solid transparent;
  }
`;
